import "@/index.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Home from "@/pages/Home";
import Pedidos from "@/pages/Pedidos";
import PedidoNovo from "@/pages/PedidoNovo";
import PedidoDetalhe from "@/pages/PedidoDetalhe";
import Recebimento from "@/pages/Recebimento";
import Estoque from "@/pages/Estoque";
import RegistrarSaida from "@/pages/RegistrarSaida";
import Produtos from "@/pages/Produtos";
import GruposSubstituicao from "@/pages/GruposSubstituicao";
import Motivos from "@/pages/Motivos";
import ConfigEmpresa from "@/pages/ConfigEmpresa";
import RelatorioSaidas from "@/pages/RelatorioSaidas";
import GestaoConsumo from "@/pages/GestaoConsumo";
import MatrizPermissoes from "@/pages/MatrizPermissoes";
import Unidades from "@/pages/Unidades";
import Ocorrencias from "@/pages/Ocorrencias";
import Relatorios from "@/pages/Relatorios";
import Devolucoes from "@/pages/Devolucoes";
import Usuarios from "@/pages/Usuarios";
import MinhaConta from "@/pages/MinhaConta";
import Inventarios from "@/pages/Inventarios";
import NumeracaoConfig from "@/pages/NumeracaoConfig";
import ResetOperacional from "@/pages/ResetOperacional";
import Categorias from "@/pages/Categorias";
import Fornecedores from "@/pages/Fornecedores";
import Compras from "@/pages/Compras";
import QRScan from "@/pages/QRScan";
import Cargas from "@/pages/Cargas";
import CargaDetalhe from "@/pages/CargaDetalhe";
import Veiculos from "@/pages/Veiculos";
import EsqueciSenha from "@/pages/EsqueciSenha";
import RedefinirSenha from "@/pages/RedefinirSenha";
import AtivarAcesso from "@/pages/AtivarAcesso";
import PrimeiroAcesso from "@/pages/PrimeiroAcesso";
import InstallPWA from "@/components/InstallPWA";
import ProducaoPainel from "@/pages/producao/ProducaoPainel";
import ProducaoFichas from "@/pages/producao/ProducaoFichas";
import ProducaoPlanejamento from "@/pages/producao/ProducaoPlanejamento";
import ProducaoCompras from "@/pages/producao/ProducaoCompras";
import ProducaoRequisicoes from "@/pages/producao/ProducaoRequisicoes";
import ProducaoOrdem from "@/pages/producao/ProducaoOrdem";
import ProducaoEstoque from "@/pages/producao/ProducaoEstoque";
import ProducaoRelatorios from "@/pages/producao/ProducaoRelatorios";

function Protected({ children }) {
  const { user, loading } = useAuth();
  if (loading || user === null)
    return <div className="min-h-screen flex items-center justify-center text-muted-foreground font-mono">Carregando…</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (user.must_change_password) return <Navigate to="/primeiro-acesso" replace />;
  return <Layout>{children}</Layout>;
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/esqueci-senha" element={<EsqueciSenha />} />
          <Route path="/redefinir-senha" element={<RedefinirSenha />} />
          <Route path="/ativar-acesso" element={<AtivarAcesso />} />
          <Route path="/primeiro-acesso" element={<PrimeiroAcesso />} />
          <Route path="/" element={<Protected><Home /></Protected>} />
          <Route path="/pedidos" element={<Protected><Pedidos /></Protected>} />
          <Route path="/pedidos/novo" element={<Protected><PedidoNovo /></Protected>} />
          <Route path="/pedidos/:id" element={<Protected><PedidoDetalhe /></Protected>} />
          <Route path="/recebimento" element={<Protected><Recebimento /></Protected>} />
          <Route path="/qr" element={<Protected><QRScan /></Protected>} />
          <Route path="/estoque" element={<Protected><Estoque /></Protected>} />
          <Route path="/estoque/saida" element={<Protected><RegistrarSaida /></Protected>} />
          <Route path="/produtos" element={<Protected><Produtos /></Protected>} />
          <Route path="/grupos-substituicao" element={<Protected><GruposSubstituicao /></Protected>} />
          <Route path="/motivos" element={<Protected><Motivos /></Protected>} />
          <Route path="/unidades" element={<Protected><Unidades /></Protected>} />
          <Route path="/ocorrencias" element={<Protected><Ocorrencias /></Protected>} />
          <Route path="/relatorios" element={<Protected><Relatorios /></Protected>} />
          <Route path="/relatorios/saidas" element={<Protected><RelatorioSaidas /></Protected>} />
          <Route path="/gestao/consumo" element={<Protected><GestaoConsumo /></Protected>} />
          <Route path="/gestao/permissoes" element={<Protected><MatrizPermissoes /></Protected>} />
          <Route path="/config/empresa" element={<Protected><ConfigEmpresa /></Protected>} />
          <Route path="/devolucoes" element={<Protected><Devolucoes /></Protected>} />
          <Route path="/usuarios" element={<Protected><Usuarios /></Protected>} />
          <Route path="/minha-conta" element={<Protected><MinhaConta /></Protected>} />
          <Route path="/inventarios" element={<Protected><Inventarios /></Protected>} />
          <Route path="/categorias" element={<Protected><Categorias /></Protected>} />
          <Route path="/fornecedores" element={<Protected><Fornecedores /></Protected>} />
          <Route path="/compras" element={<Protected><Compras /></Protected>} />
          <Route path="/config/numeracao" element={<Protected><NumeracaoConfig /></Protected>} />
          <Route path="/config/reset" element={<Protected><ResetOperacional /></Protected>} />
          <Route path="/cargas" element={<Protected><Cargas /></Protected>} />
          <Route path="/cargas/:id" element={<Protected><CargaDetalhe /></Protected>} />
          <Route path="/veiculos" element={<Protected><Veiculos /></Protected>} />
          <Route path="/producao" element={<Protected><ProducaoPainel /></Protected>} />
          <Route path="/producao/itens" element={<Navigate to="/produtos?filtro=producao" replace />} />
          <Route path="/producao/fichas" element={<Protected><ProducaoFichas /></Protected>} />
          <Route path="/producao/planejamento" element={<Protected><ProducaoPlanejamento /></Protected>} />
          <Route path="/producao/compras" element={<Protected><ProducaoCompras /></Protected>} />
          <Route path="/producao/requisicoes" element={<Protected><ProducaoRequisicoes /></Protected>} />
          <Route path="/producao/ordens/:id" element={<Protected><ProducaoOrdem /></Protected>} />
          <Route path="/producao/estoque" element={<Protected><ProducaoEstoque /></Protected>} />
          <Route path="/producao/relatorios" element={<Protected><ProducaoRelatorios /></Protected>} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
      <InstallPWA />
      <Toaster position="top-center" richColors theme="dark" />
    </AuthProvider>
  );
}

export default App;
